import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";

const FAQS = [
  {
    q: "¿Dónde opera Carlos Garcín como EOS Implementer?",
    a: "Carlos Garcín opera desde Chile, con clientes en Santiago y regiones, y extiende su servicio a toda Latinoamérica — Perú, Ecuador, Argentina, Colombia, Uruguay y Paraguay — tanto en formato presencial como virtual.",
    aJsx: (
      <>
        Carlos Garcín opera desde{" "}
        <Link to="/eos-en-chile" className="text-[#F26522] hover:underline font-medium">Chile</Link>,
        con clientes en Santiago y regiones, y extiende su servicio a toda Latinoamérica —{" "}
        <Link to="/eos-peru" className="text-[#F26522] hover:underline font-medium">Perú</Link>,{" "}
        <Link to="/eos-ecuador" className="text-[#F26522] hover:underline font-medium">Ecuador</Link>,{" "}
        <Link to="/eos-argentina" className="text-[#F26522] hover:underline font-medium">Argentina</Link>,{" "}
        <Link to="/eos-colombia" className="text-[#F26522] hover:underline font-medium">Colombia</Link>,{" "}
        <Link to="/eos-uruguay" className="text-[#F26522] hover:underline font-medium">Uruguay</Link> y{" "}
        <Link to="/eos-paraguay" className="text-[#F26522] hover:underline font-medium">Paraguay</Link>{" "}
        — tanto en formato presencial como virtual.
      </>
    ),
  },
  {
    q: "¿Qué es EOS?",
    a: "EOS (Entrepreneurial Operating System) es una metodología completa y comprobada para empresas. Combina conceptos simples con herramientas prácticas para ayudar a los equipos de liderazgo a obtener visión, tracción y un equipo más saludable. Creada por Gino Wickman.",
    aJsx: (
      <>
        EOS (Entrepreneurial Operating System) es una metodología completa y comprobada para empresas.
        Combina conceptos simples con herramientas prácticas para ayudar a los equipos de liderazgo a
        obtener visión, tracción y un equipo más saludable. Creada por{" "}
        <Link to="/historia-eos" className="text-[#F26522] hover:underline font-medium">Gino Wickman</Link>,
        puedes conocer más sobre su historia, los{" "}
        <Link to="/libros-eos" className="text-[#F26522] hover:underline font-medium">libros de la biblioteca EOS</Link>{" "}
        y el{" "}
        <Link to="/el-modelo-eos" className="text-[#F26522] hover:underline font-medium">modelo completo</Link>{" "}
        en este sitio.
      </>
    ),
  },
  {
    q: "¿Para qué tipo de empresas sirve EOS?",
    a: "Funciona especialmente bien en empresas de entre 10 y 250 colaboradores —de cualquier industria— que ya tuvieron crecimiento y hoy enfrentan complejidad, falta de foco, problemas de personas y accountability. Está probado en PYMEs, empresas familiares y empresas de tecnología.",
    aJsx: (
      <>
        Funciona especialmente bien en empresas de entre 10 y 250 colaboradores —de cualquier industria—
        que ya tuvieron crecimiento y hoy enfrentan complejidad, falta de foco, problemas de personas y
        accountability. EOS tiene implementaciones especialmente exitosas en{" "}
        <Link to="/eos-para-pymes" className="text-[#F26522] hover:underline font-medium">PYMEs en crecimiento</Link>,{" "}
        <Link to="/eos-empresas-familiares" className="text-[#F26522] hover:underline font-medium">empresas familiares</Link> y{" "}
        <Link to="/eos-empresas-tecnologia" className="text-[#F26522] hover:underline font-medium">empresas de tecnología</Link>.
      </>
    ),
  },
  {
    q: "¿Qué hace un Professional EOS Implementer?",
    a: "Un Professional EOS Implementer enseña, facilita y entrena al equipo de liderazgo para instalar las herramientas de EOS y fortalecer los seis componentes clave: Visión, Personas, Datos, Asuntos, Procesos y Tracción.",
    aJsx: (
      <>
        Un Professional EOS Implementer enseña, facilita y entrena al equipo de liderazgo para instalar
        las herramientas de EOS y fortalecer los seis componentes clave: Visión, Personas, Datos, Asuntos,
        Procesos y Tracción. Puedes conocer{" "}
        <Link to="/implementacion" className="text-[#F26522] hover:underline font-medium">el proceso completo de implementación</Link>{" "}
        paso a paso.
      </>
    ),
  },
  {
    q: "¿EOS reemplaza la planificación estratégica tradicional?",
    a: "EOS reemplaza el típico plan estratégico eterno por una visión práctica y concreta, one-page, con un ritmo trimestral de ejecución. Es estrategia aterrizada, y siempre evita documentos que terminan guardados en un cajón.",
  },
  {
    q: "¿Se puede implementar EOS de forma virtual?",
    a: "Sí. Las sesiones se realizan tanto de manera presencial como virtual, según las necesidades del equipo y la distribución geográfica de la empresa.",
  },
  {
    q: "¿Qué diferencia tiene EOS frente a otras metodologías de gestión?",
    a: "EOS no es teoría académica ni un framework abstracto. Es una metodología simple, completa y probada en miles de empresas que combina herramientas concretas, un ritmo claro y acompañamiento práctico. A diferencia de OKR, EOS aborda el sistema completo de la empresa — visión, personas, procesos y tracción — logrando una eficiencia operativa real y sostenible.",
    aJsx: (
      <>
        EOS no es teoría académica ni un framework abstracto. Es una metodología simple, completa y probada
        en miles de empresas que combina herramientas concretas, un ritmo claro y acompañamiento práctico.
        A diferencia de marcos como{" "}
        <Link to="/eos-vs-okr" className="text-[#F26522] hover:underline font-medium">OKR</Link>,
        EOS aborda el sistema completo de la empresa —visión, personas, procesos y tracción—, no solo el
        establecimiento de objetivos. El resultado es una{" "}
        <Link to="/eficiencia-operativa-empresas" className="text-[#F26522] hover:underline font-medium">eficiencia operativa</Link>{" "}
        real y sostenible.
      </>
    ),
  },
  {
    q: "¿Carlos Garcín es un consultor EOS?",
    a: "En EOS no existe formalmente la figura de 'consultor EOS'. Yo soy Professional EOS Implementer certificado: no me limito a aconsejar, implemento la metodología completa dentro de tu empresa, entrenando a tu equipo de liderazgo y acompañando la ejecución trimestre a trimestre.",
  },
  {
    q: "¿Ofreces capacitación EOS para el equipo de liderazgo?",
    a: "Entiendo la pregunta, pero hago algo más trascendente que una capacitación puntual: implemento EOS completo en tu empresa, lo que incluye entrenar a tu equipo de liderazgo en cada herramienta —Vision Building, Focus Day, Quarterly Pulsing— mientras la instalamos en la operación real del negocio, no en un curso aislado.",
  },
];

export default function FAQ() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section data-testid="faq-section" className="section-padding bg-white">
      <div className="container-eos">
        <div className="lg:grid lg:grid-cols-[1fr_300px] lg:gap-16 lg:items-start">

          {/* Columna izquierda: título + accordion */}
          <div>
            <div className="reveal">
              <span className="eyebrow">FAQ</span>
              <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-navy-800 leading-tight">
                Preguntas frecuentes sobre implementación de EOS.
              </h2>
            </div>

            <div className="mt-10 reveal">
              <Accordion type="single" collapsible className="w-full">
                {FAQS.map((f, i) => (
                  <AccordionItem
                    key={i}
                    value={`item-${i}`}
                    data-testid={`faq-item-${i + 1}`}
                    className="border-b border-slate-200"
                  >
                    <AccordionTrigger
                      data-testid={`faq-trigger-${i + 1}`}
                      className="text-left font-display font-bold text-navy-800 text-base sm:text-lg py-5 hover:no-underline hover:text-[#F26522] [&[data-state=open]]:text-[#F26522]"
                    >
                      {f.q}
                    </AccordionTrigger>
                    <AccordionContent
                      data-testid={`faq-content-${i + 1}`}
                      className="text-slate-600 text-base leading-relaxed pb-5 pr-2"
                    >
                      {f.aJsx || f.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
              <Link
                to="/faq"
                data-testid="faq-view-all-link"
                className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-[#F26522] hover:underline"
              >
                Ver todas las preguntas frecuentes sobre EOS <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>

          {/* Columna derecha: CTA sticky — solo desktop */}
          <div className="hidden lg:block">
            <div className="sticky top-28 rounded-2xl border border-slate-200 bg-slate-50 p-7 reveal">
              <span className="inline-block text-xs font-bold tracking-[0.18em] uppercase text-[#F26522] mb-4">
                ¿Tienes dudas?
              </span>
              <p className="font-display font-extrabold text-xl text-navy-800 leading-snug">
                Conversemos directamente sobre tu empresa.
              </p>
              <p className="mt-3 text-sm text-slate-500 leading-relaxed">
                Una llamada puede aclarar más que cualquier FAQ. Sin compromisos.
              </p>
              <Link
                to="/contacto"
                data-testid="faq-cta-call-btn"
                className="mt-6 w-full flex items-center justify-center gap-2 bg-[#F26522] hover:bg-[#d9561e] text-white font-bold text-sm py-3 px-5 rounded-xl transition-colors duration-200"
              >
                Agendar una llamada de 15 minutos <ArrowRight className="w-4 h-4" />
              </Link>
              <a
                href="https://wa.me/56999176009?text=Hola%20Carlos%2C%20me%20gustar%C3%ADa%20conversar%20sobre%20EOS%20para%20mi%20empresa."
                target="_blank"
                rel="noopener noreferrer"
                data-testid="faq-cta-whatsapp-btn"
                className="mt-3 w-full flex items-center justify-center gap-2 border border-slate-200 hover:border-[#F26522]/40 text-slate-600 hover:text-navy-800 font-semibold text-sm py-3 px-5 rounded-xl transition-colors duration-200 bg-white"
              >
                <MessageCircle className="w-4 h-4" /> Escríbeme por WhatsApp
              </a>
            </div>
          </div>

        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </section>
  );
}
